
const modalTriggers = document.querySelectorAll('.modal-trigger');
const modals = document.querySelectorAll('.policy-container');
const modalContainer = document.querySelector('.modal-container');

modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function handleClick(event) {
        // const modal = document.querySelector(trigger.dataset.target);
        let modalTargetAttr = '#'+trigger.getAttribute('data-target');
        let modalTarget = document.querySelector(modalTargetAttr);

        modalContainer.classList.add('open');
        // // console.log(modalTarget);
        // modalTarget.classList.remove('visible');

        modals.forEach(modal => {
            if (modal !== modalTarget) {
                modal.classList.remove('visible');
            }
            if (modal === modalTarget) {
                modal.classList.add('visible');
            }

        });

    });
});

if (document.querySelector('#privacy-policy')){
    let privacyPolicyModal = document.querySelector('#privacy-policy');
    const modalTrigger = document.querySelector('.privacy-policy-modal');
    let closeModalButton = document.querySelector('#privacy-policy .close-button');

    let firstOpen = 1;


    // modalTrigger.forEach(trigger => {
    modalTrigger.addEventListener('click', function handleClick(event) {
            openPrivacyPolicyModal();
        modalContainer.classList.add('open');
            bodyScrollLock.disableBodyScroll(modalContainer, {
                reserveScrollBarGap: true
            });
        });
    // });

    closeModalButton.addEventListener('click', (event) => {
        closePrivacyPolicyModal();
        modalContainer.classList.remove('open');
        // bodyScrollLock.enableBodyScroll(modalContainer);
    });

    function openPrivacyPolicyModal() {
        privacyPolicyModal.classList.add('visible');
        privacyPolicyModal.scrollTop = 0;
        // modalTrigger.classList.add('active');
        closeCookiesPolicyModal();

    }

    function closePrivacyPolicyModal() {
        privacyPolicyModal.classList.remove('visible');
        // modalTrigger.classList.remove('active');
    }
}

if (document.querySelector('#cookies-policy')){
    let cookiePolicyModal = document.querySelector('#cookies-policy');
    const cookieModalTrigger = document.querySelector('.cookies-policy-modal');
    let closeModalButton = document.querySelector('#cookies-policy .close-button');

    let firstOpenCookie = 1;


    // cookieModalTrigger.forEach(trigger => {
    cookieModalTrigger.addEventListener('click', function handleClick(event) {
            openCookiesPolicyModal();
        bodyScrollLock.disableBodyScroll(modalContainer, {
            reserveScrollBarGap: true
        });

        // cookieModalTrigger.classList.add('active');
        // cookiePolicyModal.document.querySelector('.privacy-policy-modal').classList.add('active');


        });
    // });

    closeModalButton.addEventListener('click', (event) => {
        closeCookiesPolicyModal();
        modalContainer.classList.remove('open');
        // bodyScrollLock.enableBodyScroll(modalContainer);
    });

    function openCookiesPolicyModal() {
        cookiePolicyModal.classList.add('visible');
        cookiePolicyModal.scrollTop = 0;
        // modalContainer.classList.add('open');


    }

    function closeCookiesPolicyModal() {
        cookiePolicyModal.classList.remove('visible');
        // cookieModalTrigger.classList.remove('active');
        // cookiePolicyModal.document.querySelector('.privacy-policy-modal').classList.remove('active');
    }
}